import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehki7b5jtd: FaireProductEntity = {
  token: "p_ehki7b5jtd",
  type: "product",
  name: "Crib Sheet - Organic cotton. No dyes, bleach or chemicals",
  brandToken: "b_d542c6whs7",
  brandName: "Blaynk",
  imageUrl: "https://cdn.faire.com/fastly/2c969fb9d44e5620ff0b9475942c220b48876f6ab767c7f0ca747d0b104231b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7963177dfb63c3f1ef77611733ffda818f68975f4a4e2dfed01446285458dee2.png",
    "https://cdn.faire.com/fastly/89f050d38ea4accf1b25eb4d9c26ec705cc27eba76d1e1940c43b3356a4eb314.jpeg",
    "https://cdn.faire.com/fastly/8cb9a27c32388b691fdd14fcfb1f1af72f115fefe29caefcb22f677b2bb14852.jpeg",
    "https://cdn.faire.com/fastly/1c0d320d15a3275a52fff8e868e1c316a702f323cde1fe6040313eea97e28812.png",
    "https://cdn.faire.com/fastly/11a687d695b3711a105d9170ca2cc75f83539df9a66cc54c7437a5ed3b2d7a8d.png"
  ],
  priceDollars: 9.5,
  description: "Organic cotton crib sheet made without chemicals or dyes. 300 thread count sateen weave. Breathable, versatile and silky soft. Our natural cotton crib sheet is perfect for taking care of your baby's delicate skin. All Blaynk fabrics are made without any dyes, bleach, or processing chemicals.\n\nIncludes: 1 fitted crib sheet",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:58.441Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
